import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Link from '../../../shared/Link/Link';
import { showHeaderMenu } from '../../../../redux/modules/showHeaderMenu';
import './CategoryMenuCards.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

class CategoryMenuCards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMegaMenuType: '',
      showMegaMenu: false,
      showCartMenu: false,
      showLogin: false,
    };
  }

  // GET CATEGORIES
  getCategories(type) {
    if (!type) {
      return [];
    }
    // Prodotti o Farmaci
    if (type === 'prodotti' || type === 'farmaci') {
      return this.props.categories.filter(category => category.type === type);
    }
    // TAG
    const tag = this.props.categoryTags.find(t => t.name === type);
    if (tag) {
      return tag.categories;
    }
    return;
  }

  render() {
    const { selectedMegaMenuType } = this.state;
    const { primaryColor, categoryTagsCardsLayout } = this.props;

    const drugsCategories = this.getCategories('farmaci');
    const productsCategories = this.getCategories('prodotti');

    const cards = !!categoryTagsCardsLayout
      ? [
          !!productsCategories.length
            ? {
                name: 'Prodotti',
                image: 'https://i.imgur.com/pW78XE5.png',
                link: '/prodotti',
                subtitle: 'Scopri tutti i prodotti del nostro shop',
              }
            : null,
          ...categoryTagsCardsLayout.map(card => ({
            ...card,
            link: `/tag-categoria/${card.name}`,
          })),
          !!drugsCategories.length
            ? {
                name: 'Farmaci',
                image: 'https://i.imgur.com/ITepkjz.png',
                link: '/farmaci',
                subtitle: 'Scopri tutta la selezione farmaceutica',
              }
            : null,
        ].filter(card => !!card)
      : [];

    return (
      <div className="external-container-categories">
        <div className="container">
          <div
            className={`grid-container categories-composition-${cards.length}`}
            style={{ display: cards.length < 3 && 'none' }}
          >
            {/* Prodotti e farmaci non sono mostrati */}
            {cards.map(categoryTag => (
              <div className="category-card">
                <Link
                  key={`category_card_${categoryTag.name}`}
                  to={categoryTag.link}
                  className={`link ${
                    selectedMegaMenuType === categoryTag.name ? 'active' : ''
                  }`}
                >
                  <h2 className="card-title">{categoryTag.name}</h2>
                  <div className="card-image">
                    <ImageDispatcher
                      src={categoryTag.image}
                      alt={`Immagine card relativa a ${categoryTag.name}`}
                    />
                  </div>
                  <h3 className="card-subtitle" style={{ color: primaryColor }}>
                    {categoryTag.subtitle}
                  </h3>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    categories: state.categories.data.categories,
    categoryTags: state.categories.data.tags,
    categoryTagsCardsLayout: state.categories.data.tagsCardsLayout,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
}

export default withRouter(
  connect(mapStateToProps, { showHeaderMenu })(CategoryMenuCards)
);
